import { ids } from "@icarros/theme-react";
import { Contrast } from "../../../types/general.types";
import { BodySizes, BodyVariants, BodyWeights } from "./constants";
import styled, { css } from "styled-components";
const { text, color } = ids || {};
const body_1 = (weight) => {
    return weight === BodyWeights.bold
        ? { ...text.body.ids_textStyle_body_01_bold }
        : { ...text.body.ids_textStyle_body_01_regular };
};
const body_2 = (weight) => {
    return weight === BodyWeights.bold
        ? { ...text.body.ids_textStyle_body_02_bold }
        : { ...text.body.ids_textStyle_body_02_regular };
};
const body_caption = (weight) => {
    return weight === BodyWeights.bold
        ? { ...text.body.ids_textStyle_caption_bold }
        : { ...text.body.ids_textStyle_caption_regular };
};
const baseStyle = css `
  color: ${color.text.body.ids_color_text_body_01};
`;
const variantStyle = css `
  color: ${color.text.body.ids_color_text_body_02};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const getBodySizeWeightStyle = (size, weight) => {
    switch (size) {
        case BodySizes.body_1:
            return body_1(weight);
        case BodySizes.body_2:
            return body_2(weight);
        case BodySizes.body_caption:
            return body_caption(weight);
        default:
            return;
    }
};
const getBodyVariantStyle = (variant, contrast) => {
    switch (variant) {
        case BodyVariants.base: {
            if (contrast === Contrast.dark)
                return onDark;
            if (contrast === Contrast.light)
                return onLight;
            return baseStyle;
        }
        case BodyVariants.variant:
            return variantStyle;
        default:
            return baseStyle;
    }
};
const StyledBody = styled.div `
  ${({ size, weight }) => getBodySizeWeightStyle(size, weight)}
  ${({ variant, contrast }) => getBodyVariantStyle(variant, contrast)}
`;
export default StyledBody;
//# sourceMappingURL=Body.style.js.map